import { PrimitiveAtom, atom, useAtom, useSetAtom } from "jotai";

const posOrderSelectedCartItemIndexAtom = atom<number | undefined>(
  null
) as PrimitiveAtom<number | undefined>;

const usePosOrderSelectedCartItemIndex = () => {
  const atom = useAtom(posOrderSelectedCartItemIndexAtom);
  return atom;
};

export const useSetPosOrderSelectedCartItemIndex = () =>
  useSetAtom(posOrderSelectedCartItemIndexAtom);

export default usePosOrderSelectedCartItemIndex;
